import { Injectable } from '@angular/core';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

/**
 * Thin wrapper around the gtag.js instance loaded in index.html.
 * All lead-generating actions should report through trackLead() using
 * the GA4 recommended `generate_lead` event so they can be marked as a
 * single Key Event in GA4 (Admin > Events > generate_lead > Mark as key event).
 */
@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  trackEvent(eventName: string, params: Record<string, any> = {}): void {
    if (typeof window === 'undefined') {
      return;
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
      return;
    }
    // Fallback so the event still reaches GTM/GA4 via the dataLayer even if
    // window.gtag hasn't been exposed as a global function for some reason.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...params });
  }

  /** method identifies the lead source, e.g. 'contact_form', 'quote_cta_click', 'phone_click', 'whatsapp_click' */
  trackLead(method: string, params: Record<string, any> = {}): void {
    this.trackEvent('generate_lead', { method, ...params });
  }
}
